'use strict';

/**
 * Updates the product attribute in the Product Detail Page
 *
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} attrValue - Attribute value for the passed attrbute id
 * @param {string} className - Attribute class name to be changed
 */
function updateTechnicalAttribute($productContainer, attrValue, className) {
    var $container = $productContainer.find(className);
    if (attrValue && attrValue.length > 0) {
        $container.find(className + '-value').html(attrValue);
        $container.removeClass('d-none');
    } else {
        $container.find(className + '-value').empty();
        $container.addClass('d-none');
    }
}

/**
 * Updates the product attributes related to Serengeti in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateTechnicalAttributes(response, $productContainer) {
    updateTechnicalAttribute($productContainer, response.product.manufacturerSKU, '.product-reference');
    updateTechnicalAttribute($productContainer, response.product.lensSize, '.product-fit');
    updateTechnicalAttribute($productContainer, response.product.dimensions, '.product-dimensions');
    updateTechnicalAttribute($productContainer, response.product.weight, '.product-weight');
    updateTechnicalAttribute($productContainer, response.product.productMaterial, '.product-material');
    updateTechnicalAttribute($productContainer, response.product.frameColor, '.frame-color');
    updateTechnicalAttribute($productContainer, response.product.color, '.product-color');
    updateTechnicalAttribute($productContainer, response.product.lensMaterial, '.lens-material');
    updateTechnicalAttribute($productContainer, response.product.lensName, '.lens-name');
    updateTechnicalAttribute($productContainer, response.product.additionalLenses, '.additional-lenses');
    updateTechnicalAttribute($productContainer, response.product.lensCategory, '.lens-category');
    updateTechnicalAttribute($productContainer, response.product.additionalLensCategory, '.additional-lens-category');
    updateTechnicalAttribute($productContainer, response.product.vlt, '.product-vlt');
    updateTechnicalAttribute($productContainer, response.product.polarization, '.product-polarization');
    updateTechnicalAttribute($productContainer, response.product.photochromy, '.product-photochromy');
    updateTechnicalAttribute($productContainer, response.product.vltAdditionalLens, '.vlt-additional-lens');
    updateTechnicalAttribute($productContainer, response.product.lensShape, '.lens-shape');
    updateTechnicalAttribute($productContainer, response.product.highContrast, '.high-contrast');
    updateTechnicalAttribute($productContainer, response.product.baseTint, '.base-tint');
    updateTechnicalAttribute($productContainer, response.product.mirrorTint, '.mirror-tint');
    updateTechnicalAttribute($productContainer, response.product.lensCoating, '.lens-coating');
    updateTechnicalAttribute($productContainer, response.product.technologies, '.product-technologies');
    updateTechnicalAttribute($productContainer, response.product.base, '.product-base');
    updateTechnicalAttribute($productContainer, response.product.mips, '.product-mips');
    updateTechnicalAttribute($productContainer, response.product.fitSystem, '.fit-system');
    updateTechnicalAttribute($productContainer, response.product.ventillation, '.product-ventillation');
    updateTechnicalAttribute($productContainer, response.product.removablePaddings, '.removable-paddings');
    updateTechnicalAttribute($productContainer, response.product.rx, '.product-rx');
    updateTechnicalAttribute($productContainer, response.product.interchangeableLenses, '.interchangeable-lenses');
    updateTechnicalAttribute($productContainer, response.product.includedAccesories, '.included-accesories');
    updateTechnicalAttribute($productContainer, response.product.certifications, '.product-certifications');

    if (response.product.isEmptyTechnicalSheet) {
        $productContainer.find('.technical-sheet-values').addClass('d-none');
        $productContainer.find('.technical-sheet-nothing-to-display').removeClass('d-none');
        $productContainer.find('.technical-sheet-nothing-to-display').addClass('d-flex');
    } else {
        $productContainer.find('.technical-sheet-values').removeClass('d-none');
        $productContainer.find('.technical-sheet-nothing-to-display').addClass('d-none');
        $productContainer.find('.technical-sheet-nothing-to-display').removeClass('d-flex');
    }
}

module.exports = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        updateTechnicalAttributes(response.data, response.container);
    });
};
